import React, { FunctionComponent } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { Login } from './pages/Login';
import { LinkAccountLogin } from './pages/LinkAccountLogin';
import { Success } from './pages/Success';
import { Error } from './pages/Error';
import { AccountSelection } from './pages/AccountSelection';
import { CheckoutConfirmation } from './pages/CheckoutConfirmation';
import GlobalWrapper from './GlobalWrapper';
import { GetDetailsFromRoute } from './components/GetDetailsFromRoute';
import ReRoute from './components/ReRoute';
import { LinkAccountSelection } from './pages/LinkAccountSelection';
import { LinkSuccess } from './pages/LinkSuccess';

const App: FunctionComponent = () => {
  return (
    <React.StrictMode>
      <title>Shift</title>
      <GlobalWrapper>
        <GetDetailsFromRoute />
        <ReRoute />
        <Route path='/'>
          <Switch>
            <Route exact path='/'>
              <Redirect to='/checkout' />
            </Route>
            <Route exact path='/checkout' component={Login} />
            <Route exact path='/select-account' component={AccountSelection} />
            <Route exact path='/confirm-checkout' component={CheckoutConfirmation} />
            <Route exact path='/success' component={Success} />
            <Route exact path='/500' component={Error} />
            <Route exact path='/account-link-intent' component={LinkAccountLogin} />
            <Route exact path='/link-select-account' component={LinkAccountSelection} />
            <Route exact path='/link-success' component={LinkSuccess} />
          </Switch>
        </Route>
      </GlobalWrapper>
    </React.StrictMode>
  );
};

export default App;
